{
  "app": {
    "name": "ForumOne"
  },
  "actions": {
    "save": "Save",
    "update": "Update",
    "cancel": "Cancel",
    "refresh": "Refresh",
    "previous": "Previous",
    "next": "Next",
    "markAllRead": "Mark all read",
    "viewDetails": "View details",
    "viewAll": "View all notifications",
    "tryAgain": "Try again",
    "approve": "Approve",
    "decline": "Decline",
    "search": "Search…",
    "signOut": "Sign out",
    "help": "Help",
    "helpSupport": "Help & Support",
    "view": "View",
    "edit": "Edit",
    "delete": "Delete"
  },
  "labels": {
    "yes": "Yes",
    "no": "No",
    "notAvailable": "N/A"
  },
  "nav": {
    "dashboard": "Dashboard",
    "appointments": "Appointments",
    "slotRequests": "Slot Requests",
    "customers": "Customers",
    "messages": "Messages",
    "providers": "Service Providers",
    "services": "Services",
    "finance": "Finance",
    "helpSupport": "Help & Support",
    "adCampaigns": "Ad Campaigns",
    "businesses": "Businesses & Institutions",
    "settings": "Settings",
    "tutorialGuide": "Tutorial Guide",
    "disabledNoBusiness": "Create a business or institution first",
    "disabledPendingApproval": "Available once your business is approved"
  },
  "adminNav": {
    "dashboard": "Dashboard",
    "businesses": "Businesses & Institutions",
    "services": "Services",
    "providers": "Service Providers",
    "adCampaigns": "Ad Campaigns",
    "pendingAdCampaigns": "Pending Ad Campaigns",
    "appointments": "Appointments",
    "customers": "Customers",
    "pendingApprovals": "Pending Approvals",
    "helpSupport": "Help & Support",
    "admins": "System Administrators",
    "messaging": "Messaging",
    "transactions": "Transactions",
    "payouts": "Payout Requests",
    "adPlans": "Ad Plans",
    "businessPlans": "Business Plans",
    "industries": "Industries",
    "settings": "Settings",
    "adminHome": "Admin"
  },
  "breadcrumbs": {
    "dashboard": "Dashboard",
    "appointments": "Appointments",
    "slotRequests": "Slot Requests",
    "customers": "Customers",
    "services": "Services",
    "providers": "Service Providers",
    "finance": "Finance",
    "support": "Help & Support",
    "adCampaigns": "Ad Campaigns",
    "business": "Businesses & Institutions",
    "settings": "Settings",
    "profile": "Profile",
    "password": "Password",
    "appearance": "Appearance",
    "language": "Language",
    "notifications": "Notifications",
    "create": "Create",
    "edit": "Edit",
    "import": "Import",
    "details": "Details",
    "businesses": "Businesses & Institutions",
    "pendingApprovals": "Pending Approvals",
    "pendingAdCampaigns": "Pending Ad Campaigns",
    "admins": "System Administrators",
    "messaging": "Messaging",
    "messages": "Messages",
    "transactions": "Transactions",
    "payouts": "Payout Requests",
    "adPlans": "Ad Plans",
    "industries": "Industries"
  },
  "errors": {
    "generic": "An error occurred",
    "required": "Required"
  },
  "commandPalette": {
    "searchPlaceholder": "Search pages and actions…",
    "empty": "No results found.",
    "groups": {
      "navigation": "Navigation",
      "actions": "Actions"
    },
    "actions": {
      "createService": "Create Service",
      "createProvider": "Create Provider",
      "createCampaign": "Create Ad Campaign"
    },
    "keywords": {
      "newService": "new service",
      "newProvider": "new provider"
    },
    "admin": {
      "dashboard": "Admin Dashboard",
      "businesses": "Businesses",
      "services": "Services",
      "providers": "Providers",
      "appointments": "Appointments",
      "customers": "Customers",
      "transactions": "Transactions",
      "payouts": "Payouts",
      "reports": "Help & Support",
      "messaging": "Messaging",
      "industries": "Industries",
      "settings": "Settings"
    }
  },
  "businessSwitcher": {
    "label": "Businesses & Institutions",
    "businessFallback": "Business or Institution",
    "noDescription": "No description",
    "viewAll": "View all businesses & institutions",
    "importViaExcel": "Import via Excel",
    "addBusiness": "Add business or institution",
    "ariaLabelSwitch": "Switch business or institution"
  },
  "dataTable": {
    "emptyTitle": "No results found",
    "emptyDescription": "Try adjusting your search or filter criteria to find what you're looking for.",
    "clearFilters": "Clear filters",
    "filterPlaceholder": "Filter...",
    "view": "View",
    "rowsSelected": "{{selected}} of {{total}} row(s) selected.",
    "showingRows": "Showing {{shown}} of {{total}}",
    "rowsPerPage": "Rows per page",
    "goToFirstPage": "Go to first page",
    "goToPreviousPage": "Go to previous page",
    "goToNextPage": "Go to next page",
    "goToLastPage": "Go to last page",
    "selectAll": "Select all",
    "selectAllRows": "Select all rows",
    "selectRow": "Select row",
    "toggleColumns": "Toggle columns"
  },
  "consoleScope": {
    "adminConsole": "Admin console",
    "business": "Business",
    "switchAriaLabel": "Switch platform or business",
    "platform": "Platform",
    "adminDescription": "Super admin & platform tools",
    "yourBusinesses": "Your businesses",
    "noBusinesses": "No businesses linked to this account yet.",
    "openDashboard": "Open business dashboard"
  },
  "modals": {
    "featureNotReadyTitle": "Feature Not Ready!",
    "featureNotReadyDescription": "This feature is not ready for use yet,\nkindly check again later.",
    "paymentSuccessTitle": "Payment successful"
  }
}
